<template>
  <div class="examinationDetailAdd">
    <!-- 体检记录 -->
    <el-form ref="addExamination" :model="form" label-width="100px" class="demo-ruleForm" :rules="rules">
      <div class="intoDetail">
        <div class="title">
          <div class="react"></div>
          <p>体检记录录入</p>
        </div>
        <div class="formtable">
          <div style="display:flex;margin-bottom:20px">
            <el-form-item label="老人姓名" prop="oldName">
              <!-- <el-select v-model="form.oldName" placeholder="请选择" @change="queryOldmanId" style="width:300px">
                <el-option v-for="item in unExamination" :key="item.value" :label="item.name"
                  :value="item.oldManId"></el-option>
              </el-select> -->
              <el-autocomplete v-model.trim="form.oldName" auto-complete="off" placeholder="请选择老人" style="width: 300px"
                :fetch-suggestions="querySearchAsync" @select="handleOlderSelect"></el-autocomplete>
            </el-form-item>
            <el-form-item label="身份证号" prop="oldIdCard" style="margin-left:170px;">
              <el-input v-model="form.oldIdCard" style="width:300px" readonly></el-input>
            </el-form-item>

          </div>
          <div style="display:flex">
            <el-form-item label="身高">
              <el-input v-model="form.height" style="width:300px">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
            <el-form-item label="体重" style="margin-left:170px;">
              <el-input v-model="form.weight" style="width:300px;">
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
          </div>
          <div style="display:flex">
            <el-form-item label="体温">
              <el-input v-model="form.temperature" style="width:300px">
                <template slot="append">℃</template>
              </el-input>
            </el-form-item>
            <el-form-item label="血糖" style="margin-left:170px;">
              <el-input v-model="form.bs" style="width:300px;">
                <template slot="append">mmol/L</template>
              </el-input>
            </el-form-item>
          </div>

          <div style="display:flex">
            <el-form-item label="心率">
              <el-input v-model="form.heart" style="width:300px">
                <template slot="append">BPM</template>
              </el-input>
            </el-form-item>
            <el-form-item label="呼吸" style="margin-left:170px;">
              <el-input v-model="form.breath" style="width:300px;">
                <template slot="append">R</template>
              </el-input>
            </el-form-item>
          </div>

          <div style="display:flex">
            <el-form-item label="血氧">
              <el-input v-model="form.boxy" style="width:300px">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="血脂" style="margin-left:170px;">
              <el-input v-model="form.bf" style="width:300px;">
                <template slot="append">mmol/L</template>
              </el-input>
            </el-form-item>
          </div>


          <div style="display:flex">
            <el-form-item label="舒张压">
              <el-input v-model="form.DBP" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="收缩压">
              <el-input v-model="form.SBP" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="记录日期" prop="examinationTime" style="margin-left:170px;">
              <el-date-picker v-model="form.examinationTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                format="yyyy-MM-dd" style="width:300px"></el-date-picker>
            </el-form-item>
          </div>
        </div>
      </div>
      <!-- 体检结果 -->
      <div class="examineresult">
        <div class="title">
          <div class="react"></div>
          <p>体检结果</p>
        </div>
        <el-form-item prop="examineresult">
          <el-input type="textarea" maxlength="128" show-word-limit v-model.trim="form.examineresult" style="width:1000px"
            placeholder="请输入内容"></el-input>
        </el-form-item>
      </div>
      <!-- 体检截图 -->
      <div class="examinationPic">
        <div class="title">
          <div class="react"></div>
          <p>体检截图</p>
        </div>
        <el-form-item prop="postPic" ref="postPic">
          <el-upload class="avatar-uploader" action="string" v-model="form.postPic" accept="image/png, image/jpeg"
            list-type="picture-card" :file-list="fileList" :http-request="uploadSectionFile"
            :before-upload="uploadSuccess" :on-remove="handleRemove" :on-success="successup" :limit="7" ref="imagePic">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item style="display:flex;justify-content:center">
          <el-button type="primary" plain @click="examinationAdd">提交</el-button>
          <el-button plain type="warning" @click="backMedicalCare">返回</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
import util from "@/utils/util.js";
export default {
  name: "examinationDetailAdd",
  data() {
    return {
      isAdd: Boolean, //判断是添加还是修改
      unExamination: [], //未体检老人信息
      fileDataList: [], //file data
      fileIndex: "",
      fileList: [],
      form: {
        oldName: "", //老人姓名
        DBP: "", //舒张压
        SBP: "", //收缩压
        height: "",
        weight: "",
        oldIdCard: "",
        examinationTime: util.formatDate.format(new Date(), "yyyy-MM-dd"), //体检时间
        psHistory: [], //既往病史
        isDisability: "", //是否残疾
        MentalDisability: "", // 精神残疾
        disabilityId: "", //残疾证编号
        PhysicalDisability: "", //肢体残疾
        drugHistory: "", //药物过敏史
        examineresult: "", //体检结果
        imageUrl: "", //体检截图
        picId: [],
        postPic: "",
        oldId: 0 //老人id
      },
      id: 0, //修改id
      rules: {
        oldName: [
          { required: true, message: "请选择未体检老人", trigger: "change" }
        ],
        DBP: [
          { required: true, message: "请输入舒张压", trigger: "blur" },
          { min: 1, max: 6, message: "长度不能超过6个字符", trigger: "blur" },
          {
            pattern: /^(0{1}|[1-9]\d{0,3}|.{0})$/,
            message: "请输入正确的舒张压",
            trigger: "blur"
          }
        ],
        SBP: [
          { required: true, message: "请输入收缩压", trigger: "blur" },
          { min: 1, max: 6, message: "长度不能超过6个字符", trigger: "blur" },
          {
            pattern: /^(0{1}|[1-9]\d{0,3}|.{0})$/,
            message: "请输入正确的收缩压",
            trigger: "blur"
          }
        ],
        height: [
          { required: true, message: "请输入身高", trigger: "blur" },
          { min: 1, max: 6, message: "长度不能超过6个字符", trigger: "blur" },
          {
            pattern: /^(0{1}|[1-9]\d{0,3}|.{0})$/,
            message: "请输入正确的身高",
            trigger: "blur"
          }
        ],
        weight: [
          { required: true, message: "请输入体重", trigger: "blur" },
          { min: 1, max: 8, message: "长度不能超过8个字符", trigger: "blur" },
          {
            pattern: /^(0(\.\d{1}){0,1}|[1-8]\d{1,3}(\.\d{1}){0,1}|9\d{1,2}(\.\d{1}){0,1}|999(\.0){0,1}|.{0})$/,
            message: "请输入正确的体重",
            trigger: "blur"
          }
        ],
        oldIdCard: [
          { required: true, message: "请输入身份证号", trigger: "change" }
        ],
        examinationTime: [
          { required: true, message: "请输入体检日期", trigger: "change" }
        ],
        examineresult: [
          { required: true, message: "请输入体检结果", trigger: "blur" },
          {
            min: 1,
            max: 280,
            message: "长度不能超过280个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.queryUnexanination(); //未体检老人
    /*
      体检详情回显
    */
    bus.$on("examinationFix", item => {
      console.log(item);
      this.isAdd = false;
      this.form = {
        oldName: item.oldName, //老人姓名
        DBP: item.dbp, //舒张压
        SBP: item.sbp, //收缩压
        height: item.height,
        weight: item.weight,
        oldIdCard: item.oldIdCard,
        examinationTime: item.examineTime, //体检时间
        disabilityId: item.disabledNo, //残疾证编号
        isDisability: String(item.isDisabled), //是否残疾
        MentalDisability: String(item.sdisabledLevel), // 精神残疾
        disabilityId: item.disabledNo, //残疾证编号
        PhysicalDisability: String(item.bdisabledLevel), //肢体残疾
        drugHistory: item.dhistory, //药物过敏史
        examineresult: item.examineResult, //体检结果
        picId: item.examinePhoto.split(";")
      };
      this.id = item.id;
      let ids = item.examinePhoto.split(";");
      console.log(ids);
      for (var i = 0; i < ids.length; i++) {
        this.fileList.push({
          name: i,
          id: i,
          url: ids[i]
        });
      }
      let psHistoryList = item.psHistory.split("-");
      let psHistoryArry = [];
      console.log(psHistoryList, "psHistoryList");
      for (var i = 0; i < psHistoryList.length; i++) {
        if (psHistoryList[i] == 1) {
          psHistoryArry.push((i + 1).toString());
        } else if (psHistoryList[i] != 1 && psHistoryList[i] != 0) {
          this.form.other = psHistoryList[i]; //其他既往病史
        }
      }
      this.form.psHistory = psHistoryArry; // 既往病史
    });
  },
  created() { },
  methods: {
    /*
      返回按钮
    */
    backMedicalCare() {
      bus.$emit("close_current_tags");
      this.$refs["addExamination"].resetFields(); //清空表单
      this.$refs.imagePic.clearFiles(); //清空图片
    },

    /* 
    模糊查询老人
    */
    querySearchAsync(queryString, cb) {
      console.log(queryString, "queryString");
      let param = {
        oldName: this.form.oldName
      };
      this.$postJson("omc/Oldman/showOldManSupIn", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.form.oldName = "";
          }, 1000);
        }
      });
    },

    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.form.oldId = item.oldmanId;
      this.form.oldIdCard = item.oldIdCard;
    },

    /*
    获取未体检老人姓名
    */
    queryUnexanination() {
      this.$postForm("omc/Examine/selectOldmans").then(res => {
        if (res.code == 200) {
          let resultArr = [];
          res.result.forEach(item => {
            if (resultArr.length == 0) {
              resultArr.push(item);
            } else {
              let isDup = false;
              resultArr.forEach((item1, index) => {
                if (item1.oldManId == item.oldManId) {
                  isDup = true;
                }
                // 一定要在循环结束后再push
                if (index == resultArr.length - 1 && !isDup) {
                  resultArr.push(item);
                }
              });
            }
          });
          this.unExamination = resultArr;
        } else {
          this.unExamination = [];
        }
      });
    },
    /*
      获取选择的老人的id
    */
    queryOldmanId(val) {
      this.form.oldId = val;
      this.getExamination(val);
    },

    /*
   未体检老人详情
   */
    getExamination(val) {
      this.$postForm("omc/Oldman/selectOldManSupByOld", { oldmanId: val }).then(
        res => {
          this.form.oldIdCard = res.result.oldIdCard;
          //既往病史
          let psHistoryList = res.result.psHistory.split("-");
          let psHistoryArry = [];
          for (var i = 0; i < psHistoryList.length; i++) {
            if (psHistoryList[i] == 1) {
              psHistoryArry.push((i + 1).toString());
            } else if (psHistoryList[i] != 1 && psHistoryList[i] != 0) {
              this.form.other = psHistoryList[i]; //其他既往病史
            }
          }
          console.log(psHistoryArry, "psHistoryArry");
          this.form.psHistory = psHistoryArry; // 既往病史
          this.form.PhysicalDisability = String(res.result.bdisabledLevel); //肢体残疾
          this.form.isDisability = String(res.result.isDisabled); //是否残疾
          this.form.MentalDisability = String(res.result.sdisabledLevel); //精神残疾
          this.form.drugHistory = res.result.dhistory; //药物过敏史
          this.form.disabilityId = res.result.disabledNo; //残疾证编号
        }
      );
    },

    //提交表单
    examinationAdd() {
      console.log(this.form.picId);
      console.log(this.rules.postPic);
      this.$refs["addExamination"].validate(valid => {
        //表单验证
        if (valid) {
          if (this.form.picId.length == 0) {
            this.$message({ message: "体检截图不能为空", type: "error" });
          } else {
            //上传表单
            let param = {
              SBP: this.form.SBP,
              DBP: this.form.DBP,
              examineresult: this.form.examineresult,
              examinetime: this.form.examinationTime,
              weight: this.form.weight,
              height: this.form.height,
              oldmanid: this.form.oldId,
              examinephoto: this.form.picId.join(";"),
              id: !this.isAdd ? this.id : ""
            };
            this.$postForm(
              this.isAdd
                ? "omc/Examine/addExamineRecord"
                : "omc/Examine/updateExamineRecord",
              param
            ).then(res => {
              if (res.code == 200) {
                this.$refs["addExamination"].resetFields(); //清空表单
                this.$refs.imagePic.clearFiles(); //清空图片
                //跳转回之前的界面
                bus.$emit('close_current_tags');
                //通知医疗保健详情页面刷新
                let changepage = "have";
                bus.$emit("changepage", changepage);
                this.$message({
                  type: "success",
                  message: res.message
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //上传图片
    uploadSectionFile(param) {
      var fileObj = param.file;
      console.log(param.file);
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("type", "image");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          this.form.picId.push(res.result); //添加图片的id
          if (res.code == 200) {
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    successup() {
      this.$refs["postPic"].clearValidate();
    },

    uploadSuccess(file) {
      console.log(this.form.picId.length, "ssssss");
      this.fileDataList.push(file);
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const limit = this.form.picId.length <= 5;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PGN 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      if (!limit) {
        this.$message.error("上传图片最多只能6张");
      }
      return isJPG && isLt2M && limit;
    },

    //删除图片
    handleRemove(file, fileList) {
      console.log(file, "sssss");
      this.form.picId = this.form.picId.filter(item => {
        return item != file.id;
      });
      for (let i = 0; i < this.fileDataList.length; i++) {
        if (file.uid == this.fileDataList[i].uid) {
          this.form.picId.splice(i + this.fileList.length, 1);
          this.fileDataList.splice(i, 1);
        }
      }
    },

    //重置按钮
    clearDetail() {
      this.$refs["addExamination"].resetFields();
      this.$refs.imagePic.clearFiles(); //清空图片
      this.form.picId = [];
      this.fileDataList = [];
      this.fileList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.examinationDetailAdd {
  .intoDetail {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    margin-top: 20px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .react {
        width: 6px;
        height: 32px;
        background: #3a77e2;
        margin-left: 30px;
        margin-right: 20px;
        margin-top: 5px;
      }

      p {
        font-size: 18px;
      }
    }

    .formtable {
      margin-left: 78px;
      padding-bottom: 15px;
    }
  }

  .medicalHistory {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    margin-top: 20px;

    .title {
      display: flex;
      align-items: center;

      .react {
        width: 6px;
        height: 32px;
        background: #3a77e2;
        margin-left: 30px;
        margin-right: 20px;
      }

      p {
        font-size: 18px;
      }
    }
  }

  .disability {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    margin-top: 20px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .react {
        width: 6px;
        height: 32px;
        background: #3a77e2;
        margin-left: 30px;
        margin-right: 20px;
        margin-top: 5px;
      }

      p {
        font-size: 18px;
      }
    }
  }

  .drugHistory {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    margin-top: 20px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .react {
        width: 6px;
        height: 32px;
        background: #3a77e2;
        margin-left: 30px;
        margin-right: 20px;
        margin-top: 5px;
      }

      p {
        font-size: 18px;
      }
    }
  }

  .examinationPic {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    margin-top: 20px;

    .img-avatar {
      width: 140px;
      height: 140px;
    }

    .uppic {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      opacity: 0;
    }

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .react {
        width: 6px;
        height: 32px;
        background: #3a77e2;
        margin-left: 30px;
        margin-right: 20px;
      }

      p {
        font-size: 18px;
      }
    }
  }

  .examineresult {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    margin-top: 20px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .react {
        width: 6px;
        height: 32px;
        background: #3a77e2;
        margin-left: 30px;
        margin-right: 20px;
      }

      p {
        font-size: 18px;
      }
    }
  }
}
</style>
